import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { cartMobx, menuMobx } from 'restaurant'
import { multiPersonMobx, decorationMobx, buyTogetherMobx } from '@mobxStore'
import { Avatar, Icon } from '@cps'
import './index.scss'

interface IProps {
  onClick: () => void;
}

const CartBar: FC<IProps> = ({ onClick }) => {
  const { mealDecorates } = decorationMobx
  const isBuyTogether = !!Config.buyTogetherId
  const total = isBuyTogether ? buyTogetherMobx.cartMenuTotal.totalCnt : cartMobx.cartResult.totalCnt
  const itemTotalPrice = isBuyTogether ? buyTogetherMobx.cartMenuTotal.itemTotalPrice : cartMobx.cartResult.itemTotalPrice + cartMobx.cartResult.discountExpressPrice
  const handleClick = () => {
    menuMobx.products.length && total && (isBuyTogether ? buyTogetherMobx.onSelectSuccess() : onClick())
  }
  return (
    <div
      className={classNames('cart-bar', { slideInUp: menuMobx.products.length && total, 'notabbar': !decorationMobx.tabBarVisible, 'has-avatar': multiPersonMobx.activePersons.length >= 2 })}
      data-cypid='cart-bar'
      onClick={handleClick}
    >
      {multiPersonMobx.activePersons?.length >= 2 && !Config.buyTogetherId && (
        <div className='center-info'>
          {/* {multiPersonMobx.activePersons.slice(0, 5).map((item) => (
            <Avatar key={item.personId} userKey={item.personId} />
          ))}
          {multiPersonMobx.activePersons.length > 5 && <span>···</span>} */}
          {multiPersonMobx.activePersons.map((item) => (
            <Avatar key={item.personId} userKey={item.personId} />
          ))}
        </div>
      )}
      <div className='left-info'>
        {
          mealDecorates.shopcart ? mealDecorates.shopcart?.mode === 1 ? (
            <img src={mealDecorates.shopcart?.pic} className='shopcart-img' />
          ) : (
            <Icon icon='dicon' name={mealDecorates.shopcart?.icon || 'mall-shopcart2'} />
          ) : (
            <Icon icon='dicon' name='mall-shopcart2' />
          )
        }
        <span className='total-cnt'>{total || '1'}</span>
      </div>
      {/* <div className='right-info'>{format.toPrice(cartMobx.cartResult.totalCartPrice - sumBy(cartMobx.cartResult.offItems?.filter(v => v.offType === 'activity') || [], 'off'))}</div> */}
      <div className='right-info' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(itemTotalPrice) }}></div>
      {!!Config.buyTogetherId && <div className='buytogeter-confirm'>{i18n.t('menu.buyTogetherConfirm')}</div>}
    </div>
  )
}

export default observer(CartBar)
